import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';

import CreateModuleModal from './CreateModuleModal';
import { newTaskActions, newTaskSelectors } from '../../state/newTask';

const mapStateToProps = state => ({
  isPending: newTaskSelectors.getAddModuleTaskCrudPending(state),
});

const mapDispatchToProps = {
  addModuleRequest: newTaskActions.addModuleTaskCrudRequest,
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onSubmit: ({
      addModuleRequest, projectId, onSuccess,
    }) => (name) => {
      addModuleRequest({ projectId, name }, {
        callbacks: {
          success: ({ projectModule }) => {
            if (onSuccess) {
              onSuccess(projectModule);
            }
          },
        },
      });
    },
  }),
);

export default enhance(CreateModuleModal);
